<div class="notifier-wrapper">
    <div class="rms-found-many">
        <div class="wrap">
            <ul>
                @for (contact of contacts; track contact) {
                <li
                    (click)="setUser(contact)"
                    [ngClass]="{
                        active: contact?.customerId === selectedContact?.customerId
                    }"
                    porAddFeature
                    featureName="consumer-select-button-{{ contact?.customerId }}">
                    <p>
                        {{ contact?.customerName | uppercase }}
                    </p>
                </li>
                }
            </ul>
        </div>
    </div>
</div>
